var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 8,
    viewBox: "0 0 15 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9258 1.50025C14.9258 1.69225 14.844 1.88425 14.6799 2.03075L8.52012 7.53025C8.1925 7.82325 7.66046 7.82325 7.33229 7.53025L1.17192 2.03075C0.843737 1.73775 0.843737 1.26325 1.17192 0.970251C1.49954 0.677251 2.03157 0.677251 2.35975 0.970251L7.92592 5.93925L13.4915 0.970252C13.8197 0.677252 14.3512 0.677252 14.6794 0.970252C14.844 1.11625 14.9258 1.30825 14.9258 1.50025V1.50025Z",
    fill: "#333333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.13ff7b4f4586c0fc0cc844ce423f868b.svg";
export { ForwardRef as ReactComponent };